export default function PriceFormat(price) {
  return new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" }).format(
    price ? price : 0,
  )
}